<template>
  <a-modal
    :title="title"
    :width="900"
    v-model="visible"
    v-if="containerData.formDataMap && containerData.tableData"
    :destroyOnClose="true"
    @ok="handleOk"
    :confirmLoading="confirmLoading"
    :bodyStyle="{
      height: '600px',
      'overflow-y': 'auto',
    }"
  >
    <div>
      <!--==============工厂信息==================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Vendor_Information') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Vendor_Name')">
              <span>{{ containerData.formDataMap.orderFactoryname }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Region')">
              <span>{{
                containerData.formDataMap.orderFactoryarea
                  ? containerData.formDataMap.orderFactoryarea.join()
                  : ''
              }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Vendor_Address')">
              <span>{{ containerData.formDataMap.orderFactoryaddress }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Contact_Name')">
              <span>{{ containerData.formDataMap.orderFactoryperson }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
              <span>{{ containerData.formDataMap.orderFactoryfixedtel }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
              <span>{{ containerData.formDataMap.orderFactorytel }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
              <span>{{ containerData.formDataMap.orderFactoryemail }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <!--==============我的信息==================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Company_Profile') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Company_Name')">
              <span>{{ containerData.formDataMap.orderTrustcompany }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Company_Address')">
              <span>{{ containerData.formDataMap.orderTrustaddress }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Contact_Name')">
              <span>{{ containerData.formDataMap.orderTrustperson }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
              <span>{{ containerData.formDataMap.orderTrustfixedtel }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
              <span>{{ containerData.formDataMap.orderTrusttel }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
              <span>{{ containerData.formDataMap.orderTrustemail }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <!--==============集装箱信息===================-->
      <div class="page-form-conent">
        <div class="span-tital">
          集装箱信息&nbsp;&nbsp;&nbsp;
        </div>
        <a-form
          :form="form"
          @submit="handleSubmit"
          v-for="datasProduct in containerData.tableData"
          :key="datasProduct.productModelid"
        >
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Product_Name')">
              <span>{{ datasProduct.productName }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Item_Number_Style')">
              <span>{{ datasProduct.productModelid }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Quantity')">
              <span>{{ datasProduct.productCount }}</span>
            </a-form-item>
            <a-form-item :label="$tc('lang.menuGoodsSpace.Units')">
              <span>{{ datasProduct.productUnit }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item :label="$tc('lang.menuGoodsSpace.Order_Number')">
              <span>{{ datasProduct.orderId }}</span>
            </a-form-item>
          </div>
          <div class="page-from">
            <a-form-item label="到达时间">
              <span>{{
                $momentData(
                  datasProduct.productDate === null ||
                    datasProduct.productDate === undefined
                    ? datasProduct.productArrivedate
                    : datasProduct.productDate,
                )
              }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <!--===============监装时间======================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Inspection_Date') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <span>{{
              $momentData(containerData.formDataMap.orderServicedate)
            }}</span>
          </div>
        </a-form>
      </div>
      <!--===============检验资料======================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Inspection_data') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form
          :form="form"
          @submit="handleSubmit"
          v-if="containerData.fileArray != null"
        >
          <div class="page-from">
            <a-upload :fileList="containerData.fileArray" :multiple="true">
            </a-upload>
          </div>
        </a-form>
      </div>
      <!--===============特别注意点======================-->
      <div class="page-form-conent">
        <div class="span-tital">
          {{ $tc('lang.menuGoodsSpace.Special_Attention') }}&nbsp;&nbsp;&nbsp;
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="page-from">
            <span>{{ containerData.formDataMap.orderRequire }}</span>
          </div>
        </a-form>
      </div>
    </div>
  </a-modal>
</template>
<!--监装-->
<script>
export default {
  name: 'supFrom',
  data() {
    return {
      //列表弹框
      visible: false,
      /*表单数据*/
      formList: {},
      form: this.$form.createForm(this),
      // 防止多次点击
      isClick: true,
      confirmLoading: false,
      title: this.$tc('lang.menuGoodsSpace.Confirm_the_Order'),
    };
  },
  // 数据状态处理全局
  computed: {
    // form表单提交的数据
    containerData: {
      get() {
        return this.$store.state.supervision.containerData;
      },
      set(value) {
        this.$store.commit('supervision/save', {
          containerData: value,
        });
      },
    },
    // 监装下单返回数据
    dataOrder: {
      get() {
        return this.$store.state.supervision.dataOrder;
      },
      set(value) {
        this.$store.commit('supervision/save', {
          dataOrder: value,
        });
      },
    },
  },
  watch: {
    containerData: function(val) {
      console.log('===val页面打开时候数据===', val);
    },
  },
  created() {},
  methods: {
    //数据初始化
    init() {
      this.visible = true;
      this.confirmLoading = false;
      this.containerData.modelType === true
        ? (this.title = this.$tc('lang.menuGoodsSpace.Order_details'))
        : this.title;
    },
    out() {
      this.visible = false;
      this.confirmLoading = false;
    },
    // 确定下单
    handleOk(e) {
      if (this.isClick) {
        this.isClick = false;
        if (this.containerData.modelType === true) {
          this.visible = false;
        } else {
          console.log('e======', e);
          const url = window.location.href;
          const theRequest = new Object();
          // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
          if (url.indexOf('?') !== -1) {
            //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
            const str = url.substr(url.indexOf('?') + 1);
            const strs = str.split('&');
            for (let i = 0; i < strs.length; i++) {
              theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
            }
          }
          if (theRequest.type === '2') {
            this.$store.commit('supervision/save', { dataOrder: false });
            this.$store.dispatch(
              'supervision/updateWorkOrder',
              this.containerData,
            );
          } else {
            console.log('=======', this.containerData);
            this.$store.commit('supervision/save', { dataOrder: false });
            this.$store.dispatch(
              'supervision/supervisionDown',
              this.containerData,
            );
          }
        }
      } else {
        this.$message.error('请勿多次点击!');
        let _this = this;
        setTimeout(function() {
          // 设置延迟事件，1秒后将执行
          _this.isClick = true; // 将isClick设置为true
        }, 1000);
      }
    },
    handleSubmit(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="less">
.page-form-conent {
  .span-tital {
    bottom: 20px;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .page-from {
    display: flex;
  }
  .ant-form-item-control {
    width: 240px;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-row {
    display: flex;
  }
  .ant-form {
    display: inline-block;
    margin-left: 88px;
  }
}
</style>
